// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewAndReactions_root__Tjazr"};